import AdminHomeGroupsListItem from './AdminHomeGroupsListItem';

export default AdminHomeGroupsListItem;
